import React, { useState } from "react";
import fondo from "./ismaael.jpeg";
import "./ComicPagina.css";
import "./Autores.css";
import { Link, useNavigate } from "react-router-dom";
import MenuPrincipal from "./MenuPrincipal";

// 📦 Importar automáticamente todos los mangas desde /pages
const pages = require.context("./pages", false, /\.jsx$/);
const obtenerTags = () => {
  const etiquetas = [];

  pages.keys().forEach((path) => {
    try {
      const modulo = pages(path);
      const info = modulo.infoManga;

      if (info?.info?.etiquetas) {
        etiquetas.push(...info.info.etiquetas);
      }
    } catch (error) {
      console.error("Error leyendo:", path, error);
    }
  });

  // Eliminar duplicados y ordenar
  return [...new Set(etiquetas.map((t) => t.trim()))].sort();
};

export default function Tags() {
  const navigate = useNavigate();

  const [letraSeleccionada, setLetraSeleccionada] = useState("A");
  const letras = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
  const tags = obtenerTags();

  // Filtrar etiquetas por letra inicial
  const filtrados = tags.filter((t) =>
    t[0]?.toUpperCase().startsWith(letraSeleccionada)
  );

  return (
    <div className="autores-page">
      {/* CABECERA */}
      <header
        className="header-fondo"
        style={{
          background: `url(${fondo}) no-repeat center center/cover`,
          padding: "40px 0",
          textAlign: "center",
          color: "#fff",
        }}
      >
             <h1
  className="titulo"
  onClick={() => navigate("/")}
  style={{ cursor: "pointer" }}
>
  TMOXNight
</h1>

       <MenuPrincipal />
            

      </header>

      {/* PAGINACIÓN ALFABÉTICA */}
      <div className="letras-container">
        {letras.map((letra) => (
          <button
            key={letra}
            className={`letra-btn ${
              letra === letraSeleccionada ? "active" : ""
            }`}
            onClick={() => setLetraSeleccionada(letra)}
          >
            {letra}
          </button>
        ))}
      </div>

      {/* GRID DE ETIQUETAS */}
      <main className="autores-contenido">
        <h2 className="titulo-autores">Etiquetas - {letraSeleccionada}</h2>
        <div className="grid-tags">
          {filtrados.length > 0 ? (
            filtrados.map((tag, i) => (
              <Link
                key={i}
                to={`/buscar?tag=${encodeURIComponent(tag)}`}
                className="tag-autor"
              >
                {tag}
              </Link>
            ))
          ) : (
            <p className="sin-autores">
              No se encontraron etiquetas con la letra "{letraSeleccionada}".
            </p>
          )}
        </div>
      </main>

      <footer>
        <p>&copy; 2024 TMOXNight. Todos los derechos reservados.</p>
      </footer>
    </div>
  );
}
